import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

import Scroll2Top from '../src/components/Other/Scroll2Top';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>

      <Scroll2Top />
      <App />
    </Router>
  </React.StrictMode>
);



